/* This is the EMIS Classes for private pre school components */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table width="800px;" border="1px;" cellspacing="0px;">
        <tbody>
          <!-- title row -->
          <tr>
            <td class="row-title">បន្ទប់រៀន</td>
            <td class="row-data">ចំនួនបន្ទប់រៀនសរុប</td>
            <td class="row-data">មានអគ្គីសនី</td>
            <td class="row-data">មានអំពូល</td>
            <td class="row-data">មានកង្ហារ/ម៉ាស៊ីនត្រជាក់</td>
            <td class="row-data">បំពាក់ឧបករណ៍ទំនើប</td>         
          </tr>
          <!-- 1st row -->
          <tr>
            <td class="row-title">សម្រាប់មត្តេយ្យសិក្សា</td>
            <td
              v-for="(value, col) in data[0].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[0].dt[col]" class="number" />
            </td>
          </tr>
          <!-- 2nd row -->
          <tr>
            <td class="row-title">សម្រាប់បឋមសិក្សា</td>
            <td
              v-for="(value, col) in data[1].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[1].dt[col]" class="number" />
            </td>
          </tr>
          <!-- 3rd row -->
          <tr>
            <td class="row-title">សម្រាប់មធ្យមសិក្សាបឋមភូមិ</td>
            <td
              v-for="(value, col) in data[2].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[2].dt[col]" class="number" />
            </td>
          </tr>
          <!-- 4th row -->
          <tr>
            <td class="row-title">សម្រាប់មធ្យមសិក្សាទុតិយភូមិ</td>
            <td
              v-for="(value, col) in data[3].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[3].dt[col]" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  computed: {
   
  },
};
</script>

<style scoped>
.number {
  width: 90px;
  text-align: center;
}
.row-data {
  width: 90px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-title {
  width: 230px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
}
</style>